import React from "react";

import { QuotationModel } from "api";
import SortTermsSelect from "components/SortTermsSelect";
import { useRequestParams } from "contexts/RequestParamsProvider";

export enum CONTRACT_LIST_SORT_KEYS {
  SHIP_DATE_START = "ShipDateStart",
  SHIP_DATE_END = "ShipDateEnd",
  CALCULATED_AMOUNT_DUE = "CalculatedAmountDue",
  CONTRACT_STATUS = "ContractStatus",
  CONTRACT_NUMBER = "ContractNumber",
  DOCUMENT_LINES_ITEM_NAME = "DocumentLines/ItemName",
}

const contractListSortOptions: SortOption<QuotationModel>[] = [
  {
    sortKey: CONTRACT_LIST_SORT_KEYS.SHIP_DATE_START,
    label: "Start Date",
  },
  {
    sortKey: CONTRACT_LIST_SORT_KEYS.SHIP_DATE_END,
    label: "End Date",
  },
  /*{
    sortKey: CONTRACT_LIST_SORT_KEYS.CALCULATED_AMOUNT_DUE,
    label: "Amount",
  },*/
  {
    sortKey: CONTRACT_LIST_SORT_KEYS.CONTRACT_STATUS,
    label: "Status",
  },
  {
    sortKey: CONTRACT_LIST_SORT_KEYS.CONTRACT_NUMBER,
    label: "Contract Number",
  },
  /*{
    sortKey: CONTRACT_LIST_SORT_KEYS.DOCUMENT_LINES_ITEM_NAME,
    label: "Product",
  }*/
];

const ContractListSort = (): React.ReactElement => {
  const { activeSort, onChangeSort } = useRequestParams();
  return (
    <SortTermsSelect
      sortOptions={contractListSortOptions}
      selectedSortKey={activeSort?.key}
      selectedDirection={activeSort?.direction}
      onChange={onChangeSort}
    />
  );
};

export default ContractListSort;
